import { Injectable } from "@angular/core";
import {
    HttpClient,
    HttpHeaders,
    HttpErrorResponse,
    HttpParams,
} from "@angular/common/http";
import { Observable, throwError, of } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { AppConfig } from "../design/app";
import { IAppConfig } from '../core/models/app-config.model';

const urlsStartPoint = "";

@Injectable({
  providedIn: 'root'
})
export class ManageEmailTemplateService {
    public appConfig: any;

  constructor(private http: HttpClient) {
    this.appConfig = AppConfig;
     }
    
    public getEmailTemplateData(): Observable<any> {
        const baseUrl = this.appConfig.emailTemplate.baseUrl;
        const getEmailTemplates = this.appConfig.emailTemplate.getEmailTemplates;
        const apiUrl: string = `${baseUrl + getEmailTemplates}`;
        const headers = new HttpHeaders();

        return this.http.get(apiUrl, { headers: headers }).pipe(
            map((res) => {
                return res
            }),

        );
    }

    public getEmailTemplateDataByID(id): Observable<any> {
        const baseUrl = this.appConfig.emailTemplate.baseUrl;
        const getEmailTemplate = this.appConfig.emailTemplate.getEmailTemplate;
        const apiUrl: string = `${baseUrl}${getEmailTemplate}?ID=${id}`;
        console.log(apiUrl);
        const headers = new HttpHeaders();
        return this.http.get(apiUrl, { headers: headers }).pipe(
            map((res) => {
                return res
            }),

        );
    }

    
    public EditEmailTemplateData(UpdatedEmailTemplateData): Observable<any> {
        const baseUrl = this.appConfig.emailTemplate.baseUrl;
        const updateEmailTemplate = this.appConfig.emailTemplate.updateEmailTemplate;
        const apiUrl: string = `${baseUrl + updateEmailTemplate}`;

        return this.http.post(apiUrl, UpdatedEmailTemplateData).pipe(
            map((res) => {
                return res
            }),
        );
    }

    public SendTestEmail(UpdatedEmailTemplateData): Observable<any> {
        const baseUrl = this.appConfig.emailTemplate.baseUrl;
        const emailTrigger = this.appConfig.emailTemplate.emailTrigger;
        const apiUrl: string = `${baseUrl + emailTrigger}`;

        return this.http.post(apiUrl, UpdatedEmailTemplateData).pipe(
            map((res) => {
                return res
            }),

        );
    }
}

